import React from 'react';

const TreeNode = ({ node, isExpanded, toggleNode }) => {
    return (
        <div className="tree-node">
            {/* Node Header */}
            <div
                className={`node-header ${node.children?.length ? 'parent-node' : ''}`}
                onClick={() => toggleNode(node.id)}
            >
                <i
                    className={`expand-icon ${
                        node.children?.length
                            ? isExpanded
                                ? 'fa-regular fa-folder-open'
                                : 'fa fa-folder'
                            : ''
                    }`}
                ></i>
                <span className="account-info">
                    <strong>{node.account_number}</strong> - {node.account_name}
                </span>
            </div>

            {/* Description */}
            <div className="node-description">{node.description}</div>

            {/* Render Children */}
            {isExpanded && (
                <div className="node-children">
                    {node.children?.map((child) => (
                        <TreeNode
                            key={child.id}
                            node={child}
                            isExpanded={child.isExpanded}
                            toggleNode={toggleNode}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default TreeNode;
